import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateDecoration'
})
export class DateDecorationPipe implements PipeTransform {

  transform(value: string): string {
    return value.replace(/([年月])/g, '<span class="format">$1</span>');
  }

}
